/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCcAmocoAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19.473 11.385c.473 0 .67.205.633.452-.082.54-.24.806-.837.805-.525 0-.662-.207-.552-.671.083-.35.32-.586.756-.586zm-6.695-.007c.473 0 .669.205.632.452-.081.54-.238.807-.835.807-.526 0-.66-.209-.553-.672.084-.35.32-.587.756-.587zm-7.488.681h-.686l.501-.624z" />
        <path d="M22 20H2V4h20zm-2.563-8.995c-1.075 0-1.58.555-1.637 1.054-.086.782.742.943 1.518.941 1.276-.003 1.678-.617 1.682-1.15.004-.734-1.046-.845-1.564-.845zM12.74 11c-1.072 0-1.577.557-1.633 1.054-.085.782.742.943 1.515.941 1.276-.003 1.678-.617 1.682-1.15.003-.734-1.046-.845-1.564-.845zm3.541 0c-.668-.002-1.502.133-1.692.92-.228.952.786 1.08 1.498 1.07.779-.011 1.289-.203 1.482-.72h-.9c-.064.175-.217.36-.694.36-.495 0-.614-.25-.467-.724.124-.4.337-.53.76-.53.504 0 .543.236.482.418l.893.005c.11-.45-.353-.799-1.362-.799zm-11.67.052L3 12.915h.919l.361-.45h1.131l.133.45h.883l-.463-1.863zm5.232.03-1.068 1.111-.33-1.112-1.386-.002-.473 1.836h.705l.353-1.282.363 1.282h.964l1.196-1.25-.442 1.25h.805l.61-1.836z" />
      </g>
    </g>
  </Icon>
);
export { SvgCcAmocoAlt as CcAmocoAlt };
